// Función para obtener la escarapela según la categoría
const getEscarapela = (category) => {
    switch(category) {
        case 'staff': return 'Staff';
        case 'conferencistas': return 'Conferencista';
        case 'asistentes': return 'Asistente';
        default: return '';
    }
}

// Función para inicializar miembros
export const initializeMembers = (group, category) => {
    const memberCount = parseInt(group[category] || 0);
    const existingMembers = group.staff_members && group.staff_members[category] ? group.staff_members[category] : [];

    return Array.from({length: memberCount}, (_, index) => {
        return existingMembers[index] || {
            nombres: '',
            apellidos: '',
            numero_de_documento: '',
            correo_electronico: '',
            tipo_de_documento: '',
            telefono: '',
            ciudad: '',
            pais: '',
            departamento: '',
            categoria: '',
            empresa: '',
            profesion: '',
            especialidad: '',
            direccion: '',
            indicativo_de_telefono: '',
            escarapela: getEscarapela(category),
            estado: ''
        };
    });
}

// Función para llenar los datos existentes
export const fillExistingData = (groupData) => {
    return groupData.map(group => ({
        ...group,
        staff_members: {
            staff: initializeMembers(group, 'staff'),
            conferencistas: initializeMembers(group, 'conferencistas'),
            asistentes: initializeMembers(group, 'asistentes')
        }
    }));
}